import { render, staticRenderFns } from "./SystemUserPermissionManage.vue?vue&type=template&id=6ddfa2f6&scoped=true"
import script from "./SystemUserPermissionManage.vue?vue&type=script&lang=js"
export * from "./SystemUserPermissionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfa2f6",
  null
  
)

export default component.exports